import { cardConfig } from "../configs/cardConfig";

const Card = ({ children, className = "", size = "medium" }) => {
  const config = cardConfig[size] || cardConfig.medium;

  return (
    <div
      className={`${config.rounded} ${config.padding} ${config.shadow} ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
